import { queryBot2 } from 'boot/axios';
import TreeNode from './TreeNode';

export default class extends TreeNode {
    constructor () {
        super();

        this.type = 'view';
        this.innertype = 'view';
        this.label = 'Новый вид';
        this.content = '';
    }

    save () {
        return this.saveData(this.content);
    }

    saveData (saveData) {
        const descr = String(saveData);
        const mockupId = this.getParentBy('innertype', 'mockup')?.serverId || 0;
        if (this.serverId) {
            return queryBot2('update-tree-node', {
                title: this.label,
                descr,
                target: this.parent?.serverId || this.target,
                serverId: this.serverId,
            });
        }
        return queryBot2('insert-portfolio-doc', {
            title: this.label,
            type: this.type,
            descr,
            target: this.parent?.serverId || 0,
            mockupId,
        })
            .then((resp) => {
                this.serverId = resp.data.id;
            });
    }

    initData (data) {
        this.serverId = data.id;
        this.label = data.title;
        this.target = data.target;
        this.content = data.description?.replaceAll('\'', '"');
    }
}
